// const proxy_ip = 'http://172.23.100.152'
// const proxy_ip = 'http://172.23.100.124'
const proxy_ip = 'http://apiWebvisitor'
// const proxy_ip = 'http://172.23.100.83'

module.exports = {
  proxy_ip
}
